import React from "react";
import ReactDOM from 'react-dom'
import css from "./style.scss";
import cn from "classnames";
import Header from 'components/header';
import store from 'utils/store'
import CloseIcon from 'react-icons/lib/md/close'
import Keyboard from 'components/shared/keyboard'
import {push} from 'react-router-redux'
import {Motion, spring} from 'react-motion';

var scrollTo = require('scroll-to');


export class PopupPage extends React.Component{
  constructor(props){
    super(props)
    this.handleCloseDetails=this.handleCloseDetails.bind(this)
  }
  componentDidMount(){
    document.body.className=document.body.className+" popup-open"
  }
  componentWillUnmount(){
    document.body.className=document.body.className.replace("popup-open","")
  }
  handleCloseDetails(){
    if(!this.props.dontClose){
      if(this.props.backTo){
        if(typeof this.props.backTo ==="function"){
          this.props.backTo()
        }else{
          store.dispatch(push(this.props.backTo))
        }
      }
    }
  }

  render(){
    const classes=cn(
      css.wrapper,
      this.props.containerClass,
      this.props.fullHeight ? css.fullHeight : "",
      this.props.noMargins ? css.noMargins : "",
      this.props.width==="small" ? css.small : "",
      this.props.width==="medium" ? css.medium : "",
    )
    let modalEl=document.getElementById("modals");
    return ReactDOM.createPortal(
      (<div className={cn(css.popupPage, this.props.className, this.props.onTop ? css.onTop : "")}>
        <Keyboard keypress="esc" onPress={this.handleCloseDetails}>
          <div className={classes}>
            {!this.props.dontClose &&
              <div className={css.menuBar}>
                <div onClick={this.handleCloseDetails} className={css.close}><CloseIcon size={24}/></div>
              </div>
            }
            {this.props.title && <h3>{this.props.title}</h3>}
            {this.props.children}
          </div>
        </Keyboard>
      </div>),
    modalEl,
    );
  }
}

export const FullContainer=(props)=>{
  if(props.grey){
    return (
      <div className={cn(css.greyContainer, props.classContainer)}>
        <div className={cn(css.container, css.fullContainer, props.className)}>
          {props.children}
        </div>
      </div>
    )
  }

  if(props.noAnimation){
    return (
      <div style={{opacity:1,  transform: "translate(0, 0)"}} className={cn(css.container, css.fullContainer, props.className)}>
        {props.children}
      </div>
    )
  }else{
    return (
      <Motion defaultStyle={{marginTop: -20, opacity:0}} style={{opacity:spring(1), marginTop: spring(0)}}>
        {style =>{
          return (<div style={{opacity:style.opacity,  transform: "translate(0, "+style.marginTop+"px)"}} className={cn(css.container, css.fullContainer, props.className)}>
            {props.children}
          </div>)
        }
        }
      </Motion>

    )
  }

}

export class FullPage extends React.Component{
  componentDidMount(){
    scrollTo(0, 0, {
      ease: 'in-out-quart',
      duration: 700
    })
  }
  render(){
    return (
      <div className={cn(css.fullPage,this.props.className, this.props.dotted ? css.dotted : "", )}>
        <Header withPadding/>
        {this.props.withContainer &&
        <FullContainer className={cn(this.props.containerClass)}>
          {this.props.children}
        </FullContainer>}
        {!this.props.withContainer && this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/container/index.js